import * as moment from "moment";
export var ESortOrder;
(function (ESortOrder) {
    ESortOrder[ESortOrder["ASC"] = 1] = "ASC";
    ESortOrder[ESortOrder["DESC"] = -1] = "DESC";
    ESortOrder[ESortOrder["UNCHANGED"] = 0] = "UNCHANGED";
})(ESortOrder || (ESortOrder = {}));
export const ratingWeightage = {
    AAAPlusStable: 1,
    AAAPlus: 2,
    AAAStable: 3,
    AAA: 4,
    AAAMinusStable: 5,
    AAAMinus: 6,
    AAPlusStable: 7,
    AAPlus: 8,
    AAStable: 9,
    AA: 10,
    AAMinusStable: 11,
    AAMinus: 12,
    APlusStable: 13,
    APlus: 14,
    AStable: 15,
    A: 16,
    AMinusStable: 17,
    AMinus: 18,
    BBBPlusStable: 19,
    BBBPlus: 20,
    BBBStable: 21,
    BBB: 22,
    BBBMinusStable: 23,
    BBBMinus: 24,
    BBPlusStable: 25,
    BBPlus: 26,
    BBStable: 27,
    BB: 28,
    BBMinusStable: 29,
    BBMinus: 30,
    BPlusStable: 31,
    BPlus: 32,
    BStable: 33,
    B: 34,
    BMinusStable: 35,
    BMinus: 36,
    CCCPlusStable: 37,
    CCCPlus: 38,
    CCCStable: 39,
    CCC: 40,
    CCCMinusStable: 41,
    CCCMinus: 42,
    CCPlusStable: 43,
    CCPlus: 44,
    CCStable: 45,
    CC: 46,
    CCMinusStable: 47,
    CCMinus: 48,
    CPlusStable: 49,
    CPlus: 50,
    CStable: 51,
    C: 52,
    CMinusStable: 53,
    CMinus: 54,
    DDDPlusStable: 55,
    DDDPlus: 56,
    DDDStable: 57,
    DDD: 58,
    DDDMinusStable: 59,
    DDDMinus: 60,
    DDPlusStable: 61,
    DDPlus: 62,
    DDStable: 63,
    DD: 64,
    DDMinusStable: 65,
    DDMinus: 66,
    DPlusStable: 67,
    DPlus: 68,
    DStable: 69,
    D: 70,
    DMinusStable: 71,
    DMinus: 72,
};
export const getScore = (rating) => {
    let RatingKey = rating
        .replace("(", "")
        .replace(")", "")
        .replace("+", "Plus")
        .replace("-", "Minus");
    return RatingKey;
};
export const getHighestRating = (ratings) => {
    let RatingList = ratings.split(",");
    let HighestRating = "D-";
    let HighestRatingKey = "DMinus";
    RatingList.map((rating) => {
        let RatingScore = rating.split("=>")[1];
        const ratingKey = getScore(RatingScore);
        if (ratingWeightage[ratingKey] <
            ratingWeightage[HighestRatingKey]) {
            HighestRating = RatingScore;
            HighestRatingKey = ratingKey;
        }
    });
    return HighestRatingKey;
};
export function ratingSort(data, sortKey, sortOrder) {
    return [...data].sort((a, b) => {
        let weightingA = ratingWeightage[getHighestRating(a[sortKey])];
        let weightingB = ratingWeightage[getHighestRating(b[sortKey])];
        if (weightingA < weightingB) {
            return 1 * sortOrder;
        }
        if (weightingA > weightingB) {
            return -1 * sortOrder;
        }
        return 0;
    });
}
export function dateSorting(data, sortKey, sortOrder) {
    return [...data].sort((a, b) => {
        if (moment(a[sortKey]).diff(moment(b[sortKey]), "days") < 0) {
            return 1 * sortOrder;
        }
        if (moment(a[sortKey]).diff(moment(b[sortKey]), "days") > 0) {
            return -1 * sortOrder;
        }
        return 0;
    });
}
export function stringSort_depricated(data, sortKey, sortOrder) {
    var _a;
    return (_a = [...data]) === null || _a === void 0 ? void 0 : _a.sort((a, b) => {
        if (a[sortKey] < b[sortKey]) {
            return 1 * sortOrder;
        }
        if (a[sortKey] > b[sortKey]) {
            return -1 * sortOrder;
        }
        return 0;
    });
}
export function dateSort(data, sortKey, sortOrder) {
    switch (sortOrder) {
        case ESortOrder.ASC:
            return [...data].sort((a, b) => {
                return moment(a[sortKey]).diff(moment(b[sortKey]));
            });
        case ESortOrder.DESC:
            return [...data].sort((a, b) => {
                return moment(b[sortKey]).diff(moment(a[sortKey]));
            });
        default:
            return data;
    }
}
export function stringSort(data, sortKey, sortOrder) {
    return [...data].sort((a, b) => {
        if (a[sortKey] < b[sortKey]) {
            return 1 * sortOrder;
        }
        if (a[sortKey] > b[sortKey]) {
            return -1 * sortOrder;
        }
        return 0;
    });
}
export const sortData = (sortStateData, filterData) => {
    if (sortStateData.type === "string") {
        return stringSort(filterData, sortStateData.key, sortStateData.order);
    }
    else if (sortStateData.type === "Date")
        return dateSort(filterData, sortStateData.key, sortStateData.order);
    else {
        return sort(filterData, sortStateData.key, sortStateData.order);
    }
};
export default function sort(data, sortKey, sortOrder) {
    return [...data].sort((a, b) => {
        let left;
        let right;
        if (isNaN(+a[sortKey])) {
            left = 0;
        }
        else {
            left = +a[sortKey];
        }
        if (isNaN(+b[sortKey])) {
            right = 0;
        }
        else {
            right = +b[sortKey];
        }
        if (left < right) {
            return -1 * sortOrder;
        }
        if (left > right) {
            return 1 * sortOrder;
        }
        return 0;
    });
}
